import { useMemo } from 'react'

import { PaymentOrderInfoDocument } from '__generated__/atlas-types'

import { Order } from 'types'
import { relayConnectionToArray } from 'utils/transformations/graphql'

import { atlas } from 'graphql/tags'

import { OrderErrors } from 'features/Orders/Review/review.queries'
import { useOrdersQuery } from 'features/Orders/orders.hooks'

atlas`#graphql
  query PaymentOrderInfo($filters: OrderFilterInput!) {
    orders(filters: $filters) {
      edges {
        node {
          id
          webOrderLookupId
          brand {
            id
            name
          }
          billing {
            address {
              name
              firstAddress
              secondAddress
              city
              country
              state
              phone
              zip
            }
          }
          referenceNumber
          retailerProfile {
            id
            name
            displayName
            email
          }
          priceType {
            id
            name
            currency {
              id
              name
              code
            }
          }
          shipping {
            ...OrderShippingDetails
          }
          status
          statusModified
          financials {
            dueTotal {
              minPrice
              maxPrice
            }
          }
        }
      }
    }
  }
`

type PaymentOrderFields =
  | 'id'
  | 'webOrderLookupId'
  | 'brand'
  | 'billing'
  | 'referenceNumber'
  | 'retailerProfile'
  | 'priceType'
  | 'shipping'
  | 'tax'
  | 'status'
  | 'statusModified'
  | 'financials'

export type PaymentOrderInfo = Pick<Order, PaymentOrderFields>
type UsePaymentOrderInfoReturnType = {
  order?: PaymentOrderInfo
  error?: OrderErrors
  loading?: boolean
}

export const usePaymentOrderInfo = (): UsePaymentOrderInfoReturnType => {
  const { data, loading } = useOrdersQuery(
    PaymentOrderInfoDocument,
    {},
    { errorPolicy: 'all', fetchPolicy: 'network-only' },
  )

  const order = useMemo<PaymentOrderInfo | undefined>(
    () => relayConnectionToArray((data as any)?.orders)?.[0],
    [(data as any)?.orders],
  )

  return {
    order,
    loading,
  }
}
